module.exports = __webpack_public_path__ + "assets/images/announcement-sensor-offline.png";